export const RoutePutAuthPassword = "/auth/password";

export type PayloadPutAuthPassword = {
  currentPassword: string;
  newPassword: string;
};
